import { EvolucoesProblemaModalQuery } from 'graphql/types.generated'

import { EvolucaoProblema as EvolucaoProblemaModel } from '../types/ProblemaModel'

type EvolucaoProblema = EvolucoesProblemaModalQuery['problema']['evolucoes'][0]

export default (evolucaoProblema: EvolucaoProblema): EvolucaoProblemaModel => {
  return {
    id: evolucaoProblema.id,
    dataInicio: evolucaoProblema.dataInicio,
    dataFim: evolucaoProblema.dataFim,
    situacao: evolucaoProblema.situacao,
    observacao: evolucaoProblema.observacao,
    atualizadoEm: evolucaoProblema.atualizadoEm,
    atendimentoProfissional: evolucaoProblema.atendimentoProfissional,
  }
}
